<div class="create-wall-result">
  <div class="create-wall-result__toolbar">
    <input
      class="ui-input create-wall-result__name"
      [value]="name()"
      [placeholder]="'WALL_LIST.TABLE.HEADER.WALL_NAME' | translate"
      (input)="onNameInput($event)"
    />

    <ui-camera-select-button
      class="create-wall-result__camera-select"
      [selectedCount]="selectedCameraList().length"
      (click)="openSelectCameraModal()"
    ></ui-camera-select-button>

    <div
      class="create-wall-result__alert-select"
      [matTooltip]="(hasMultipleSets()
        ? 'WALL_CREATE.TOOLTIPS.CANNOT_ADD_ALERTS'
        : 'WALL_CREATE.TOOLTIPS.NO_FREE_TILES') | translate"
      [matTooltipDisabled]="!hasMultipleSets() && !alertSelectorHasNoFreeCells()"
    >
      <div>
        <ui-v2-selector
          [options]="alertOptions()"
          [multi]="true"
          searchProperty="name"
          valueProperty="_id"
          [formControl]="alertsControl"
          [placeholder]="'ALARM_CREATE.ALERTS' | translate"
          [disabled]="hasMultipleSets()"
          [disabledOptionsMap]="alertOptionsDisabledMap()"
          [tooltipForDisableoption]="'WALL_CREATE.TOOLTIPS.NO_FREE_TILES' | translate"
        ></ui-v2-selector>
      </div>
    </div>

    <div
      [matTooltip]="'WALL_CREATE.TOOLTIPS.CANNOT_ADD_SETS' | translate"
      [matTooltipDisabled]="!selectHasWallAlert()"
    >
      <div
        class="flex-row start-center create-wall-result__set-controls"
        [class.disabled]="selectHasWallAlert()"
      >
        <mat-select
          class="ui-selector set-selector create-wall-result__set-selector"
          [value]="selectWallSetIndex()"
          (selectionChange)="changeSet($event)"
        >
          @for (set of selectWallSets(); track set; let i = $index) {
            <mat-option [value]="i">
              {{ set.name }}
            </mat-option>
          }
        </mat-select>
        <span
          class="ui-icon-set-rotation ui-static-icon-button-32 sets c-p create-wall-result__set-settings"
          [matTooltip]="'WALL_CREATE.TOOLTIPS.SETS_CONFIGURATION' | translate"
          (click)="openSetSettingsModal()"
        ></span>
      </div>
    </div>

    <span
      class="ui-icon-layout ui-static-icon-button-32 create-wall-result__layout-select"
      [matTooltip]="'WALL_CREATE.TOOLTIPS.LAYOUT' | translate"
      (click)="openLayoutConfigModal()"
    ></span>

    <span
      class="ui-icon-settings ui-static-icon-button-32 c-p create-wall-result__settings-button"
      [matTooltip]="'WALL_CREATE.TOOLTIPS.WALL_SETTINGS' | translate"
      (click)="openWallSettings()"
    ></span>

  </div>

  <div class="create-wall-result__set-label">
    {{ selectedSetLabel() }}
  </div>

  <div class="create-wall-result__layout tiles flex-col h-100 min-h-0 min-w-0" cdkDropListGroup>
    <v2-set-layout
      class="h-100 w-100"
      [set]="currentSet()"
      [viewMode]="false"
      [checkPermissions]="false"
      (onCleanTile)="cleanTile($event)"
      (onEventRemoved)="onTileEventRemoved($event)"
      (onEventsChanged)="onTileEventsChanged($event)"
      (onTileDrag)="onTileDragged($event)"
    ></v2-set-layout>
  </div>
</div>
